import * as React from 'react';
import PropTypes from 'prop-types';

const SvgNavigationGroupNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M23.42 14.42l-.74-1.38a3.215 3.215 0 00-2.85-1.72h-5.66a3.216 3.216 0 00-2.85 1.72l-.7 1.3c-.1-.017-.2-.023-.3-.02H4.66a3.242 3.242 0 00-2.86 1.72l-.73 1.38a2.213 2.213 0 001.96 3.25h8.92a2.208 2.208 0 002.07-3h7.44a2.213 2.213 0 001.96-3.25zM22.2 15.9a.838.838 0 01-.74.42h-8.14l-.15-.28a3.211 3.211 0 00-1.24-1.29l.58-1.08a1.888 1.888 0 011.66-1h5.66a1.889 1.889 0 011.66 1l.73 1.38a.834.834 0 01-.02.85zm-9.49 2.15a.863.863 0 01-.76 1.27H3.03a.838.838 0 01-.74-.42.878.878 0 010-.9L3 16.67a1.878 1.878 0 011.66-1h5.67a1.943 1.943 0 011.65 1l.73 1.38zM17 9.68a3.175 3.175 0 10-.01-6.35A3.175 3.175 0 0017 9.68zm0-5a1.825 1.825 0 11-.01 3.65A1.825 1.825 0 0117 4.68zm-9.5 7.97a3.17 3.17 0 100-6.34 3.17 3.17 0 000 6.34zm0-5a1.83 1.83 0 110 3.66 1.83 1.83 0 010-3.66z"
        fill=""
      />
    </svg>
  )
);
SvgNavigationGroupNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgNavigationGroupNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgNavigationGroupNormalSmall;
